import "./home.css";
import { useState, useEffect } from "react";
import { Content } from "./homepagelogo";
import { Link } from "react-router-dom";

let Home = () => {
  let [Planets, setPlanets] = useState([]);

  useEffect(() => {
    setPlanets(Content);
  }, []);

// setInterval(()=>{
//       location.reload();
// },1000);


  return (
    <div className="Home">
      {Planets.map((obj) => {
        if (obj.Top && obj.Left) {
          return (
            <Link to={obj.link}>
              <div className="planet" style={{ top: obj.Top, left: obj.Left }}>
                <img src={obj.image} alt="planet" />
                <p>{obj.name}</p>
              </div>
            </Link>
          );
        } else if (obj.Top) {
          return (
            <Link to={obj.link}>
              <div
                className="planet"
                style={{ top: obj.Top, right: obj.Right }}
              >
                <img src={obj.image} alt="planet" />
                <p>{obj.name}</p>
              </div>
            </Link>
          );
        } else if (obj.Left) {
          return (
            <Link to={obj.link}> 
              <div
                className="planet"
                style={{ bottom: obj.Bottom, left: obj.Left }}
              >
                <img src={obj.image} alt="planet" />
                <p>{obj.name}</p>
              </div>
            </Link>
          );
        } else {
          return (
            <Link to={obj.link}>
              <div
                className="planet"
                style={{ bottom: obj.Bottom, right: obj.Right }}
              >
                <img src={obj.image} alt="planet" />
                <p>{obj.name}</p>
              </div>
            </Link>
          );
        }
      })}
      <div className="Home-Centre-Content">
        <img className="Logo" src="dsclogo.png" alt="logo" />
        <p>
          {" "}
          <span style={{ color: "#EA4335" }}>Google</span>
          <span style={{ color: "#FBBC05" }}> Developer</span>
          <span style={{ color: "#34A853" }}> Student</span>
          <span style={{ color: "#4285F4" }}> Clubs</span>
        </p>
        <p style={{ color: "#7ed6df" }}>
          Guru Tegh Bahadur Institute Of Technology
        </p>

        <button>
          {" "}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://gdsc.community.dev/guru-tegh-bahadur-institute-of-technology-delhi/"
          >
            Become a Member{" "}
          </a>
        </button>
      </div>
    </div>
  );
};

export default Home;